import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useLayout } from '../../../../../../providers/Layout.provider';

const { Box, Button, Title, SubTitle } = vp;

type ErrorProps = {
  ErrorMessage: string;
  SecondaryErrorMessage: string;
  TryAgain: () => void;
};

type FC = FunctionComponent<ErrorProps>;

const Error: FC = (props: ErrorProps) => {
  const { ErrorMessage, SecondaryErrorMessage, TryAgain } = props;
  const { color } = useLayout();
  const { t } = useTranslation('translations', { keyPrefix: 'OnlineBanking' });

  return (
    <>
      <Box flx="col" pb="md" width="100%" height="auto">
        <Title title={ErrorMessage} />
      </Box>
      {SecondaryErrorMessage && (
        <Box flx="col" pb="md" width="100%" height="auto">
          <SubTitle center subTitle={SecondaryErrorMessage} />
        </Box>
      )}
      <Box mt="md" height="auto">
        <Button
          id="login"
          label={`${t('tryAgainButton')}`}
          type="submit"
          background={color}
          textColor={vp.getContrastColor(color)}
          width="100%"
          size="xlg"
          round
          bold
          noShadow
          textSize={1}
          onClick={() => {
            TryAgain();
          }}
        />
      </Box>
    </>
  );
};

export default Error;
